import React from "react";

import { Chip } from "@mui/material";

import { Currency } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import {
  currencyDisplayMapping,
  currencySymbolMapping,
} from "../../constants/index";

interface CurrencyFormatterProps {
  priceInCents: number;
  currency: Currency;
  showChipStyle?: boolean;
}

const CurrencyFormatter = ({
  priceInCents,
  currency,
  showChipStyle,
}: CurrencyFormatterProps) => {
  const symbol = currencySymbolMapping[currency];
  const price = priceInCents / 100;
  const currencyLabel = currencyDisplayMapping[currency];

  let content;
  switch (currency) {
    case Currency.EUR:
      content = `${price}${symbol} (${currencyLabel})`;
      break;
    default:
      content = `${symbol}${price} (${currencyLabel})`;
      break;
  }
  return showChipStyle ? (
    <Chip variant="outlined" color="primary" label={<b>{content}</b>} />
  ) : (
    <b>{content}</b>
  );
};

export default CurrencyFormatter;
